import {
  checkNull,
  KeyValPair,
  ListContent,
  ReportContainer,
} from "../constant";
import { formatHomeCareSummary } from "./home-care-summary";

interface PhysicalExamBlockProps {
  data: any;
}

const PhysicalExamBlock = ({ data }: PhysicalExamBlockProps) => {
  if (!checkNull(data?.physicalTemplates)) return null;

  return (
    <ReportContainer label="Physical Exam">
      <ListContent
        list={data?.physicalTemplates}
        renderItem={(item) =>
          item?.description && (
            <KeyValPair
              k={item?.templateNameType}
              v={
                formatHomeCareSummary(
                  item?.templateNameType,
                  item?.description
                ) || ""
              }
            />
          )
        }
      />
    </ReportContainer>
  );
};

export default PhysicalExamBlock;
